/* eslint-disable */
import React, {useEffect, useState} from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import {
  Box,
  Breadcrumbs,
  Link,
  Typography,
  Paper,
  Grid,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { CustomButton } from '../../../../components/CustomButton';
import { ReactComponent as EditIcon } from '../../../../assets/images/edit.svg';
import { ReactComponent as BoxIcon } from '../../../../assets/images/box-red.svg';
import { DoubleField } from '../../../support/components/DoubleField';
import { ROUTES, getRouteWithParam } from '../../../../constants/routes';
import {
  getPromotionById,
  getCMS,
  getCustomerFiles,
  getPromoCodes,
  archivePromotion
} from '../../../../store/partners/actions';
import { CircularProgressCenter } from '../../../../components/CircularProgressCenter';
import { formatDate } from '../../../../utils/formatDate';
import { CustomModal } from '../../../../components/CustomModal';
import { PROMO_CODES_STATUSES, PROMOCODES_HEAD_CELLS } from '../../constants';
import { Tab } from '../../../../components/Tab';
import EnhancedTable from '../../../../components/EnhancedTable';
import { getMailingColorStatus } from '../../../mailing/constants';
import { ReactComponent as CouponIcon } from '../../../../assets/images/coupon.svg';
import { ReactComponent as DownloadIcon } from '../../../../assets/images/download.svg';
import { ReactComponent as UploadIcon } from '../../../../assets/images/upload.svg';
import { PromocodesTableBody } from '../../components/PromocodesTableBody';
import { ReportModal } from '../../components/ReportModal';
import { ReactComponent as CopyIcon } from '../../../../assets/images/copyIcon.svg';
import { ReactComponent as ClockIcon } from '../../../../assets/images/clock.svg';
import { ReactComponent as UpdateIcon } from '../../../../assets/images/update.svg';
import { CustomExpand } from '../../../../components/CustomExpand';
import { getEventDeclensionForm } from '../../../../utils/getEventDeclension';
import { SUBSCRIBERS_HEAD_CELLS } from '../../../bonuses/constants/headCell';
import { SubscribersTableBody } from '../../../bonuses/components/SubscribersTableBody';
import { CustomSelect } from '../../../../components/CustomSelect';
import { FirstTextSelect } from '../../../../components/FirstTextSelcet';
import { setUsersPermissions } from '../../../../utils/setUsersPermissions';
import { visibleBySectionPermission } from '../../../../utils/visibleBySectionPermission';
import { DISABLED_CONTROL_TOOLTIP, IMAGE_ACCEPT, PERMISSIONS } from '../../../../constants/variables';
import axios from 'axios';
import { serviceLocalStorage } from '../../../../utils/serviceLocalStorage';
import { ReactComponent as ReportRedIcon } from '../../../../assets/images/report_red.svg';
import { apiClient } from '../../../../api/setupApi';
import { useDropzone } from 'react-dropzone';
import { getAssetUrl } from '../../../../utils/getAssetUrl';
import { PromotionDescriptionContent } from '../../components/PromotionDescriptionContent';

const TABS = {
  DETAILING: 'DETAILING',
  LIST: 'LIST',
  PROMOCODES: 'PROMOCODES'
}

export const DetailPromotion = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { promotionCard, cms, promoCodes, fetchingPromotions, customerFiles } = useSelector((state) => state.partners);
  const { userPermissions, currentUsersPermissions } = useSelector((state) => state.userPermissions);
  const permissions = setUsersPermissions(userPermissions, currentUsersPermissions?.permissions);

  const isAllowedToEdit = visibleBySectionPermission(permissions, PERMISSIONS.PARTNER.updatePartnerPromotions.value);
  const isAllowedToArchive = visibleBySectionPermission(permissions, PERMISSIONS.PARTNER.archivePartnerPromotions.value);
  const isAllowedToRetrieve = visibleBySectionPermission(permissions, PERMISSIONS.PARTNER.retrievePartnerPromotions.value);
  const isAllowedToCopy = visibleBySectionPermission(permissions, PERMISSIONS.PARTNER.copyPartnerPromotions.value);
  const isAllowedToHistory = visibleBySectionPermission(permissions, PERMISSIONS.LOGGING.ListHistory.value);

  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [downloadModal, setDownloadModal] = useState(false);
  const [isErrorModal, setIsErrorModal] = useState('');
  const [currentTab, setCurrentTab] = useState(TABS.DETAILING);
  const [filterFiles, setFilterFiles] = useState({
    order_by: 'created_at',
    order_type: 'desc',
    page: 0,
    size: 10,
  });
  const [filterPromoCodes, setFilterPromoCodes] = useState({
    order_by: 'created_at',
    order_type: 'desc',
    page: 0,
    size: 10,
    status: PROMO_CODES_STATUSES[0]
  });
  const [updatesFieldsStatus, setUpdatesFieldsStatus] = useState(false);

  const cmsPackage = cms?.find(item => item?.id === promotionCard?.cms_package?.id) || promotionCard?.cms_package;

  useEffect(() => {
    dispatch(getPromotionById(id));
    dispatch(getCMS());
  }, []);

  useEffect(() => {
    dispatch(getCustomerFiles(id, {
      ...filterFiles,
      page: filterFiles.page + 1
    }));
  }, [
    filterFiles.order_type,
    filterFiles.page,
    filterFiles.size,
    filterFiles.order_by
  ]);

  useEffect(() => {
    dispatch(getPromoCodes({
      ...filterPromoCodes,
      page: filterPromoCodes.page + 1,
      promotion_id: id,
      status: filterPromoCodes.status.value !== PROMO_CODES_STATUSES[0].value ? filterPromoCodes.status.value : undefined,
    }));
  }, [
    filterPromoCodes.order_type,
    filterPromoCodes.page,
    filterPromoCodes.size,
    filterPromoCodes.order_by,
    filterPromoCodes.status
  ]);

  const uploadReport = (files) => {
    const file = files[0];
    let formData = new FormData();
    formData.append('file', file);

    apiClient.post(`/partners/promotions/${id}/file/promocode/report`, formData)
      .then(() => dispatch(getPromoCodes({
        ...filterPromoCodes,
        page: filterPromoCodes.page + 1,
        promotion_id: id,
        status: filterPromoCodes.status.value !== PROMO_CODES_STATUSES[0].value ? filterPromoCodes.status.value : undefined,
      })))
      .catch(({ response }) => setIsErrorModal(JSON.stringify(response.data.detail)));
  }

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: uploadReport,
    accept: '.xls, .xlsx',
  });

  const updateFieldData = () => {
    dispatch(getCMS({ update: true })).then(res => {
      if (res.status === 200) setUpdatesFieldsStatus(true);
    });
  };

  const dateToStringForFilter = date => `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}-${date.getUTCDate()} ${date.getUTCHours()}:${date.getUTCMinutes()}`;

  const downloadFile = (name, link) => {
    axios.get(`${process.env.REACT_APP_API_URL}/partners/promotions/${id}/file/promocode/${link}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${serviceLocalStorage.getAccessToken()}`
      }
    }).then((response) => {
      const href = URL.createObjectURL(response.data);

      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
  }

  const isCardArchived = promotionCard.status === 'archive' || promotionCard.status === 'Архив';

  if (promotionCard?.id !== +id || !Object.values(promotionCard).length || !cms.length || !cmsPackage)
    return <CircularProgressCenter data-testid="CircularProgressCenter"/>;

  if (!isAllowedToRetrieve) return null;

  return (
    <>
      <Box>
        <Breadcrumbs mb="24px" aria-label="breadcrumb">
          <Link component={RouterLink} underline="hover" color="inherit" to={ROUTES.PARTNERS}>
            Партнёры
          </Link>

          <Typography sx={{ lineBreak: 'anywhere' }}>{cmsPackage.name}</Typography>
        </Breadcrumbs>

        <Paper sx={{ padding: '32px', display: 'flex', justifyContent: 'space-between' }}>
          <img src={getAssetUrl(cmsPackage.banner)} width="360px" height="250px" alt="logo" />
          <Box ml="24px" width="90%">
            <Box display="flex" mb="16px" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography color="text.secondary" sx={{ fontSize: '18px' }}>
                  {promotionCard?.id}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'left', gap: '10px' }}>
                  <Typography variant="h1" mb="8px" mt="8px" sx={{ color: 'text.primary', lineBreak: 'auto' }} component="h1">
                    {cmsPackage?.name}
                  </Typography>
                  <UpdateIcon
                    style={{
                      cursor: 'pointer',
                      marginTop: '13px',
                      width: '20px',
                      height: '20px',
                    }}
                    onClick={() => updateFieldData()}
                    fill={updatesFieldsStatus ? '#90BC34' : '#151C22'}
                  />
                </Box>
                <PromotionDescriptionContent description={cmsPackage?.description} />
              </Box>
              <Box data-testid="CurrentStatus" color={`${getMailingColorStatus(promotionCard?.status)}`}>{promotionCard.status}</Box>
            </Box>

            <CustomButton
              color="secondary"
              variant="outlined"
              size="small"
              sx={{ marginRight: '16px', display: isCardArchived ? 'none' : undefined }}
              startIcon={<EditIcon />}
              component={RouterLink}
              to={getRouteWithParam(ROUTES.PARTNERS_ADD_PROMOTION, ':id', id)}
              data-testid="EditBonus"
              disabled={!isAllowedToEdit}
              tooltip={isAllowedToEdit ? null : DISABLED_CONTROL_TOOLTIP}
            >
              Редактировать
            </CustomButton>

            <CustomButton
              color="secondary"
              variant="outlined"
              size="small"
              sx={{ marginRight: '16px' }}
              startIcon={<CopyIcon />}
              component={RouterLink}
              to={getRouteWithParam(ROUTES.PARTNERS_COPY_PROMOTION, ':id', id)}
              disabled={!isAllowedToCopy}
              tooltip={isAllowedToCopy ? null : DISABLED_CONTROL_TOOLTIP}
            >
              Копировать
            </CustomButton>

            <CustomButton
              color="secondary"
              variant="outlined"
              size="small"
              sx={{ marginRight: '16px' }}
              startIcon={<ClockIcon />}
              component={RouterLink}
              to={getRouteWithParam(ROUTES.PARTNERS_HISTORY_PROMOTION, ':id', id)}
              disabled={!isAllowedToHistory}
              tooltip={isAllowedToHistory ? null : DISABLED_CONTROL_TOOLTIP}
            >
              История событий
            </CustomButton>

            <CustomButton
              color="error"
              variant="outlined"
              size="small"
              sx={{ marginRight: '16px', display: isCardArchived ? 'none' : undefined }}
              startIcon={<BoxIcon />}
              onClick={isAllowedToArchive ? () => setIsSuccessModal(true) : undefined}
              data-testid="ArchiveBonus"
              disabled={!isAllowedToArchive}
              tooltip={isAllowedToArchive ? null : DISABLED_CONTROL_TOOLTIP}
            >
              В архив
            </CustomButton>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'left',
                flexWrap: 'wrap',
                marginTop: '24px'
              }}>
              <DoubleField
                title="Дата старта"
                description={formatDate(promotionCard?.date_start)}
                data-testid="StartDate"
              />
              <DoubleField
                title="Дата окончания"
                description={formatDate(promotionCard?.date_end, true)}
                data-testid="EndDate"
              />

              <Box data-testid="City">
                <Typography sx={{ color: 'text.secondary', minWidth: 180 }}>Города</Typography>
                { promotionCard?.all_cities ?
                  <Typography sx={{ fontWeight: 500, fontSize: '20px' }}>Все</Typography> :
                  promotionCard?.cities.length ?
                    <CustomExpand items={promotionCard?.cities}/> :
                    <Typography sx={{ fontWeight: 500, fontSize: '20px' }}>-</Typography>
                }
              </Box>

              <DoubleField title="Отоброжать для" description={promotionCard?.show_all ? 'Всех' : 'по списку'} data-testid="ToAll"/>

            </Box>
          </Box>
        </Paper>

        <Box display="flex" justifyContent="space-between" data-testid='Tabs'>
          <Box display="flex">
            <Tab
              label="Детализация"
              setTypeTable={() => setCurrentTab(TABS.DETAILING)}
              typeCurrent={currentTab}
              typeDefault={TABS.DETAILING}
            />
            {!promotionCard.show_all &&
              <Tab
                label="Списки абонентов"
                setTypeTable={() => setCurrentTab(TABS.LIST)}
                typeCurrent={currentTab}
                typeDefault={TABS.LIST}
              />
            }
            <Tab
              label="Промокоды"
              setTypeTable={() => setCurrentTab(TABS.PROMOCODES)}
              typeCurrent={currentTab}
              typeDefault={TABS.PROMOCODES}
            />
          </Box>
        </Box>

        {currentTab === TABS.DETAILING && (
          <Paper
            sx={{
              padding: '24px',
              display: 'flex',
              justifyContent: 'space-between'
            }}>
            <Grid container>
              <Grid item xs={3}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                  <Typography variant="body1" color="text.secondary">
                    Компания
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 500
                    }}>
                    {promotionCard?.partner?.name}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                  <Typography variant="body1" color="text.secondary">
                    Сумма предлагаемой скидки
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 500
                    }}>
                    {promotionCard?.discount ? `${promotionCard?.discount}%` : '-'}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={5}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                  <Typography variant="body1" color="text.secondary">
                    Web страница для получения услуги из МП
                  </Typography>
                  <Link
                    href={promotionCard?.site_url}
                    target="_blank"
                    variant="subtitle2"
                    color={promotionCard?.site_url ? "primary.main" : "text.main"}
                    underline={promotionCard?.site_url ? 'hover' : 'none'}
                    sx={{
                      fontWeight: 500,
                      maxWidth: '500px',
                      wordBreak: 'break-all'
                    }}
                  >
                    {promotionCard?.site_url || '-'}
                  </Link>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        )}

        {currentTab === TABS.LIST &&
          <EnhancedTable
            rows={customerFiles.items || []}
            headCells={SUBSCRIBERS_HEAD_CELLS}
            total={customerFiles?.total || 0}
            fetching={fetchingPromotions}
            heightRow={109}
            filter={filterFiles}
            setFilter={setFilterFiles}
          >
            <SubscribersTableBody data={customerFiles.items} link={'/partners/promotions/file/'}/>
          </EnhancedTable>
        }

        {currentTab === TABS.PROMOCODES && (
          <Box data-testid="PromotionsTab" mt="-16px">
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <CustomSelect
                name="status"
                options={PROMO_CODES_STATUSES}
                value={filterPromoCodes.status}
                startAdornmentText={<FirstTextSelect text='Статус:' />}
                size='small'
                variant='outlined'
                sx={{ width: '240px', mt: '16px' }}
                onChange={e => setFilterPromoCodes({ ...filterPromoCodes, page: 0, status: e })}
              />
              <Box display="flex">
                <CustomButton
                  sx={{
                    border: '1px solid #DDE1E5',
                    boxSizing: ' border-box',
                    borderRadius: '12px',
                    padding: '6px 16px !important',
                    color: '#151C22',
                    mt: '16px',
                  }}
                  size="small"
                  onClick={() => downloadFile(`Список промокодов ${id}`, 'info')}
                >
                  <Box mr={1} display="flex" alignItems="center">
                    <CouponIcon />{' '}
                  </Box>
                  Выгрузить список промокодов
                </CustomButton>
                <Box
                  {...getRootProps({
                    className: 'dropzone multiple'
                  })}
                >
                  <input {...getInputProps()} multiple={false} />
                  <Box>
                    <CustomButton
                      sx={{
                        border: '1px solid #DDE1E5',
                        boxSizing: ' border-box',
                        borderRadius: '12px',
                        padding: '6px 16px !important',
                        color: '#151C22',
                        mt: '16px',
                        ml: '20px'
                      }}
                      size="small"
                    >
                      <Box mr={1} display="flex" alignItems="center">
                        <DownloadIcon />{' '}
                      </Box>
                      Загрузить отчет
                    </CustomButton>
                  </Box>
                </Box>
                <CustomButton
                  sx={{
                    border: '1px solid #DDE1E5',
                    boxSizing: ' border-box',
                    borderRadius: '12px',
                    padding: '6px 16px !important',
                    color: '#151C22',
                    mt: '16px',
                    ml: '20px'
                  }}
                  size="small"
                  onClick={() => setDownloadModal(true)}
                >
                  <Box mr={1} display="flex" alignItems="center">
                    <UploadIcon />{' '}
                  </Box>
                  Выгрузить отчет
                </CustomButton>
              </Box>
            </Box>
            <Typography color="text.secondary" paddingTop="15px" mb="24px">
              Найдено {getEventDeclensionForm(promoCodes?.items?.length, 'promocodes')}
            </Typography>

            <EnhancedTable
              rows={promoCodes?.items}
              headCells={PROMOCODES_HEAD_CELLS}
              filter={filterPromoCodes}
              total={promoCodes?.total || 0}
              fetching={fetchingPromotions}
              heightRow={77}
              setFilter={setFilterPromoCodes}
            >
              <PromocodesTableBody
                data={promoCodes?.items}
              />
            </EnhancedTable>
          </Box>
        )}
        <CustomModal
          opened={isSuccessModal}
          modalClose={() => setIsSuccessModal(false)}
          modalSubmit={() => {
            dispatch(archivePromotion(id))
            setIsSuccessModal(false);
          }}
          text="Вы действительно хотите перевести данную партнёрскую акцию в Архив?"
          cancelBtnName="Отмена"
          submitBtnName="Да"
          data-testid="Warning Modal"
        />
        <CustomModal
          opened={!!isErrorModal}
          modalClose={() => setIsErrorModal('')}
          text={isErrorModal}
          cancelBtnName="Готово"
          withoutSubmit
          icon={<ReportRedIcon />}
        />
        <ReportModal
          showModal={downloadModal}
          setShowModal={setDownloadModal}
          download={(date_start, date_end) => downloadFile(`Отчет по промокодам ${id}`, 'report')}
        />
      </Box>
  </>
  );
};
